/* Solo — compatibility with bundle / quantity-break apps (Kaching Bundles).
   When the app widget sits in the product section, Add to cart posts the product
   form itself (like a standard Shopify theme), so whatever the app writes into the
   form (quantity, bundle properties, extra items) reaches the cart unchanged. */
(function () {
  const APP_SELECTOR = 'kaching-bundle, kaching-bundles-block, [class*="kaching-bundles"], [id*="kaching-bundles"], .shopify-app-block[data-block-handle*="kaching"]';

  function ensureQuantityField(form) {
    if (!form || form.elements.namedItem('quantity')) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'quantity';
    input.value = '1';
    form.appendChild(input);
  }

  async function addForm(form, opts) {
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || (Solo.strings && Solo.strings.cartError) || 'Error');
    await Solo.cart.afterChange(json.sections, opts);
    Solo.emit('cart:added', { items: json.items || [json] });
    return json;
  }

  customElements.whenDefined('s-product').then(() => {
    const proto = customElements.get('s-product').prototype;
    const original = proto.addToCart;

    proto.usesBundleApp = function () {
      if (!this.form) return false;
      // Only when the app actually rendered a deal (an empty widget = normal theme behaviour).
      return [...this.querySelectorAll(APP_SELECTOR)].some((el) => el.childElementCount > 0 || el.shadowRoot || el.offsetHeight > 0);
    };

    proto.addToCart = async function (opts = {}) {
      if (!this.usesBundleApp()) return original.call(this, opts);
      if (!this.variant || !this.variant.available) return;
      this.showError('');
      if (!this.validateFields(opts.fromSticky)) return;
      ensureQuantityField(this.form);
      const skip = opts.checkout || (this.atc && this.atc.dataset.skipCart === 'true');
      const button = opts.button;
      if (button) button.classList.add('is-loading');
      try {
        await addForm(this.form, { open: !skip });
        const extras = this.extraItems().filter((it) => it.id !== this.variant.id);
        if (extras.length) await Solo.cart.add(extras, { open: !skip });
        if (skip) window.location.href = '/checkout';
      } catch (e) {
        this.showError(e.message);
        if (opts.fromSticky && this.sticky) this.sticky.flashError(e.message);
      }
      if (button) button.classList.remove('is-loading');
    };

    document.querySelectorAll('s-product').forEach((p) => {
      if (p.usesBundleApp()) ensureQuantityField(p.form);
    });
  });
})();
